import { render, staticRenderFns } from "./MenuLogotype.vue?vue&type=template&id=a52dac04&scoped=true&"
import script from "./MenuLogotype.vue?vue&type=script&lang=ts&"
export * from "./MenuLogotype.vue?vue&type=script&lang=ts&"
import style0 from "./MenuLogotype.vue?vue&type=style&index=0&id=a52dac04&prod&lang=scss&scoped=true&"
import style1 from "./MenuLogotype.vue?vue&type=style&index=1&id=a52dac04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52dac04",
  null
  
)

export default component.exports